export default {
  name: "NavbarSection",
  data() {
    return ({
      is_nav_open: false
    });
  },

  methods: {
    toggle_nav() {
      this.is_nav_open = !this.is_nav_open;
    },
    close_nav() {
      this.is_nav_open = false;
    }
  }
};
